<div class="error-container">
  <div class="error-content">
    <h1 class="error-code">404</h1>
    <h2 class="error-title">Page Not Found</h2>
    <p class="error-message">
      The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
    </p>
    <a routerLink="/dashboard" class="error-link">Go to Dashboard</a>
  </div>
</div>

